import { PcnType } from '@luminovo/api-contracts';
import { searchParam } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { z } from 'zod/v4';

import { PcnsPage } from '@/areas/risk-management/Pcns/PcnsPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/risk-management/pcns')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'home' } satisfies PageStaticData,
    validateSearch: z.object({
        tab: searchParam.enum(PcnType, 'optional'),
        start: z.string().optional(),
        end: z.string().optional(),
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { tab, start, end } = Route.useSearch();
    return <PcnsPage tab={tab} start={start} end={end} />;
}
